import {
  DANGEROUS_RED,
  SECONDARY_GRAY
} from "@pathwright/ui/src/components/utils/colors"
import styled from "styled-components"
import SubmitHandler, { SUBMIT_STATUS } from "../../submit/SubmitHandler"
import SubmitStatus from "../../submit/SubmitStatus"

const StyledSubmitStatus = styled(SubmitStatus)`
  font-size: 12px;
`

const getSubmitColor = (status) => {
  switch (status) {
    case SUBMIT_STATUS.FAILURE:
      return DANGEROUS_RED
    default:
      return SECONDARY_GRAY
  }
}

const FormSubmitStatus = ({
  submitting,
  submitFailure,
  submitSuccess,
  resetStatus,
  ...rest
}) => (
  <SubmitHandler
    submitting={submitting}
    submitFailure={submitFailure}
    submitSuccess={submitSuccess}
    resetStatus={resetStatus}
  >
    {({ status }) => (
      <StyledSubmitStatus
        className="FormSubmitStatus"
        status={status}
        iconColor={getSubmitColor(status)}
        spinnerColor={getSubmitColor(status)}
        size={12}
        {...rest}
      />
    )}
  </SubmitHandler>
)

FormSubmitStatus.displayName = "FormSubmitStatus"

export default FormSubmitStatus
